import styled from "styled-components";

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-word;
`;

export const Value = styled.span`
  color: ${({ theme }) => theme.palette[850]};
  white-space: pre-wrap;
`;

export const Label = styled.span`
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette[650]};
  letter-spacing: 0.4px;
`;

export const SecondaryValue = styled.span`
  color: ${({ theme }) => theme.palette[650]};
  white-space: pre-wrap;
`;

export const EmptyValue = styled.span`
  color: ${({ theme }) => theme.palette[650]};
`;

export const Mono = styled.code`
  background-color: ${({ theme }) => theme.palette[50]};
  color: ${({ theme }) => theme.palette[800]};
  font-size: 12px;
  line-height: 16px;
  padding: 2px 4px;
  border-radius: 4px;
  word-break: break-word;
  white-space: pre-wrap;
`;
